// src/components/SearchModal/LabelCheckbox.jsx
const LabelCheckbox = ({ checkbox, isSfOpen, handleCheckboxChange }) => {
 // チェック状態に応じてクラスを設定
 const labelClassName = `sf-controls-checkbox__label ${checkbox.checked ? "sf-controls-checkbox__label--checked" : ""} ${checkbox.className || ""}`;

 return (
  <label htmlFor={checkbox.id} className={labelClassName} key={checkbox.id}>
   <input
    type="checkbox"
    checked={checkbox.checked}
    disabled={checkbox.count === 0}
    tabIndex={`${!isSfOpen ? "0" : "-1"}`}
    onChange={() => {
     handleCheckboxChange(checkbox.id);
    }}
    id={checkbox.id}
    value={checkbox.checkbox_name}
    data-count-rest={checkbox.count}
    data-count-all={checkbox.allCount}
   />
   <span className="sf-controls-checkbox__name">{checkbox.checkbox_name}</span>
   <span className="sf-controls-checkbox__count">
    <span className="sf-controls-checkbox__count-filtered">{checkbox.count}</span>
    <span className="sf-controls-checkbox__count-slash" aria-label="/"></span>
    <span className="sf-controls-checkbox__count-all">{checkbox.allCount}</span>
   </span>
  </label>
 );
};

export default LabelCheckbox;
